module.exports = __webpack_public_path__ + "static/img/wzyf_icon.a93f388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wzyf_icon.png
// module id = t5EL
// module chunks = 1